import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import _ from "lodash";
import config from "../config";

const AUTH_KEY = `${config.CLIENT_ID}_auth`;
const PROFILE_KEY = `${config.CLIENT_ID}_profile`;
const USERID_KEY = `${config.CLIENT_ID}_userIdKey`;
const HISTORY_KEY = `${config.CLIENT_ID}_history`;
const HISTORY_VIEW_KEY = `${config.CLIENT_ID}_history_view`;
const ENCRYPTOR_KEY: string = config.CLIENT_SECRET as string;

export const getCookie = (cookieName: string, str: any): any => {
    if (Cookies.get(cookieName) !== undefined) {
        const bytes = CryptoJS.AES.decrypt(
            Cookies.get(cookieName)!,
            ENCRYPTOR_KEY,
        );
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData[str];
    }
    return null;
};

export const setCookie = (cookieName: string, objCookies: any): any => {
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(objCookies),
        ENCRYPTOR_KEY,
    );
    Cookies.set(cookieName, ciphertext.toString(), { path: "/" });
    return Cookies;
};

const generateAuthCookiesForUser = (resp: any) => {
    const authCookies = _.assign({
        [`${config.PROJECT_APP}_isLoggedIn`]: true,
        [`${config.PROJECT_APP}_accessTokenUser`]: resp.access_token,
        [`${config.PROJECT_APP}_refreshToken`]: resp.refresh_token,
        [`${config.PROJECT_APP}_expired`]: resp.expires_in,
    });
    return authCookies;
};
const generateAuthCookiesForRegisteredUser = (resp: any) => {
    const authCookies = _.assign({
        [`${config.PROJECT_APP}_isLoggedIn`]: true,
        [`${config.PROJECT_APP}_accessTokenUser`]: resp.access_token,
    });
    return authCookies;
};
const generateProfileCookies = (resp: any) => {
    const profileCookies = _.assign({
        [`${config.PROJECT_APP}_authToken`]: resp.authToken,
    });
    return profileCookies;
};
const generateUserIdCookies = (id: any) => {
    const userIdCookies = _.assign({
        [`${config.PROJECT_APP}_userid`]: id,
    });
    return userIdCookies;
};

export const setUserIdCookies = (id: string): void => {
    setCookie(USERID_KEY, generateUserIdCookies(id));
};

export const setSessionLoginForUser = (resp: any): void => {
    setCookie(AUTH_KEY, generateAuthCookiesForUser(resp));
    setCookie(PROFILE_KEY, generateProfileCookies(resp));
};
export const getSessionForLoginUser = (): any => {
    return getCookie(AUTH_KEY, `${config.PROJECT_APP}_accessTokenUser`);
};
export const setSessionRegisterForUser = (resp: any): void => {
    setCookie(AUTH_KEY, generateAuthCookiesForRegisteredUser(resp));
};
const generateHistoryViewForUser = (resp: any) => {
    const historiesView = getHistoriesViewAgent();
    const storedValue = historiesView !== null ? [...historiesView] : [];
    storedValue.push(resp);

    const convertToString = JSON.stringify(storedValue);
    const viewNameCookies = _.assign({
        [`${config.PROJECT_APP}_histories_view`]: convertToString,
    });

    return viewNameCookies;
};

export const deleteHistorySearchItem = (resp: any) => {
    const historiesSearch = getHistoriesSearchAgent();

    const index = historiesSearch.indexOf(resp);
    if (index > -1) {
        historiesSearch.splice(index, 1);
    }

    const convertToString = JSON.stringify(historiesSearch);
    const searchNameCookies = _.assign({
        [`${config.PROJECT_APP}_histories`]: convertToString,
    });

    return searchNameCookies;
};

export const setHistoryViewAgent = (resp: any): void => {
    setCookie(HISTORY_VIEW_KEY, generateHistoryViewForUser(resp));
};

export const setDeleteHistoryAgentItem = (resp: any): void => {
    setCookie(HISTORY_KEY, deleteHistorySearchItem(resp));
};

export const clearCookie = (cookieName: string): void => {
    Cookies.remove(cookieName, { path: "/" });
};
export const getUserToken = (): any => {
    return getCookie(USERID_KEY, `${config.PROJECT_APP}_tokenUser`);
};

export const getUserId = (): any => {
    return getCookie(USERID_KEY, `${config.PROJECT_APP}_userid`);
};

export const getUsername = (): any => {
    return getCookie(PROFILE_KEY, `${config.PROJECT_APP}_username`);
};

export const getToken = (): any => {
    // return getCookie(AUTH_KEY, `${config.PROJECT_APP}_accessTokenUser`);
};
export const getHistoriesSearchAgent = (): any => {
    const historiesSearch = getCookie(
        HISTORY_KEY,
        `${config.PROJECT_APP}_histories`,
    );
    const convertToArray = JSON.parse(historiesSearch);

    return convertToArray;
};

export const getHistoriesViewAgent = (): any => {
    const historyView = getCookie(
        HISTORY_VIEW_KEY,
        `${config.PROJECT_APP}_histories_view`,
    );
    const convertToArray = JSON.parse(historyView);

    return convertToArray;
};

export const logout = (): void => {
    clearCookie(PROFILE_KEY);
    clearCookie(AUTH_KEY);
    clearCookie(USERID_KEY);
    clearCookie(HISTORY_KEY);
};

export const clearHistories = (): void => {
    clearCookie(HISTORY_KEY);
};

export const clearHistoriesView = (): void => {
    clearCookie(HISTORY_VIEW_KEY);
};
